import { render, staticRenderFns } from "./thresholds-config.vue?vue&type=template&id=4e9cbc7a&"
import script from "./thresholds-config.vue?vue&type=script&lang=js&"
export * from "./thresholds-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports